import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Card.css';

const Card = ({ className = '', padding = true, children, ...otherProps }) => {

  const classes = classNames(
    'ng-ui-widgets',
    'ng-ui-card',
    { 'ng-ui-card-padding': padding },
    className,
  );

  return (
    <div
      className={classes}
      {...otherProps}
    >
      { children }
    </div>
  );
};

Card.propTypes = {
  padding: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
};

export default Card;